import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import Spa from './barba/Spa';

export class Lofi {
	constructor() {
		// Promises waarop gewacht  wordt. Standaard wordt er gewacht op het 'DOMContentLoaded' event
		Promise.all([Lofi.domReady()]).then(() => this.init());
	}

	init() {
		new Spa();
	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new Lofi();
